import React from 'react';
import _get from 'lodash/get';
import _isString from 'lodash/isString';
import _isObject from 'lodash/isObject';

import { ErrorPage, NotFound } from 'views/Errors';
import { logError } from 'utils/extra';
import { connectError } from 'utils/connectors/AppConnectors';

const FALLBACK_MESSAGE = 'Something went wrong. Please try again later.';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: this.props.hasError };
  }
  componentDidUpdate(prevProps) {
    // Dependent on AuthContext
    if (prevProps.hasError !== this.props.hasError) {
      this.setState({
        hasError: this.props.hasError
      });
    }
  }
  componentDidCatch(error, info) {
    // Display fallback UI
    if (this.state.hasError) return;
    this.setState({ hasError: true });
    // Log to external reporting service
    logError(error, { componentStack: info.componentStack });
  }

  render() {
    const { errorObject, children } = this.props;
    const displayMessage = _get(errorObject, 'displayMessage', null);
    const statusCode = _get(errorObject, 'statusCode', null);
    const method = _get(errorObject, 'method', null);

    if (!this.state.hasError) {
      return children;
    }

    if (_isObject(errorObject) && statusCode === 404 && method === 'get') {
      return <NotFound />;
    }

    const message = _isString(errorObject)
      ? errorObject
      : _isObject(errorObject)
      ? _isString(displayMessage)
        ? displayMessage
        : _isObject(displayMessage)
        ? _get(displayMessage, 'message', FALLBACK_MESSAGE)
        : FALLBACK_MESSAGE
      : FALLBACK_MESSAGE;

    return <ErrorPage message={message} />;
  }
}

export default connectError(ErrorBoundary);
